import { differenceInCalendarDays, parseISO } from 'date-fns'

import { getDaysPastDeadline } from '@features/vatDeclarations/utils/getDaysPastDeadline'

import { SubmitStatus } from '../elements/VatDeclaration/enums/submitStatus'
import { VatDeclarationStatus } from '../enums/vatDeclarationStatus'

interface GetVatDeclarationStatusProps {
  isPaid?: boolean
  isPayable?: boolean
  isSettled?: boolean
  periodEndDate?: string
  submissionStatus?: SubmitStatus
  reportDeadline?: string
}

export const getVatDeclarationStatus = ({
  isPaid,
  isPayable,
  isSettled,
  periodEndDate,
  submissionStatus,
  reportDeadline,
}: GetVatDeclarationStatusProps): VatDeclarationStatus => {
  const today = new Date()
  /* Specific NL case so far, might be reused for other integrations */
  if (submissionStatus === SubmitStatus.Processing || submissionStatus === SubmitStatus.Sent) {
    return VatDeclarationStatus.Pending
  }

  if (submissionStatus === SubmitStatus.Failed) {
    return VatDeclarationStatus.SubmissionFailed
  }

  if (isPaid) {
    return VatDeclarationStatus.Paid
  }

  if (!isPayable && isSettled) {
    return VatDeclarationStatus.Paid
  }

  if (reportDeadline && getDaysPastDeadline(reportDeadline) > 0) {
    return isSettled ? VatDeclarationStatus.OverduePayment : VatDeclarationStatus.OverdueSubmission
  }

  if (isSettled) {
    return VatDeclarationStatus.ReadyToPay
  }

  /* Ready to submit when the period _actually_ ends, so difference is not 0 */
  if (periodEndDate && differenceInCalendarDays(today, parseISO(periodEndDate)) > 0) {
    return VatDeclarationStatus.ReadyToSubmit
  }

  return VatDeclarationStatus.Draft
}
